import axios from 'axios';

const API_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:3010';

const getAuthToken = () => {
  return localStorage.getItem('accessToken') || '';
};

export const getUserProfile = async (): Promise<any> => {
  const { data } = await axios.get(`${API_URL}/auth/profile`, {
    headers: {
      Authorization: `Bearer ${getAuthToken()}`
    }
  });
  return data;
};

export const updateLanguagePreference = async (
  language: string
): Promise<void> => {
  await axios.patch(
    `${API_URL}/users/me/language`,
    { language },
    {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        'Content-Type': 'application/json'
      }
    }
  );
};
